import React, { Component, Fragment } from "react";
import { Graphics, Text, withPixiApp } from "@inlet/react-pixi";
import withKeyboardListenerConfiguration from "./configuration/withKeyboardListenerConfiguration";

import * as PIXI from "pixi.js";

import { connect } from "react-redux";
import { IStore } from "../../store/IStore";
import { Dispatch } from "redux";

import { actions as winpresentationAction } from "../../reducers/winPresentationReducer";


import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';

import "react-toggle/style.css"
import { isMobile } from "react-device-detect";
import { actions as buttonActions } from "../../reducers/buttonPanelReducer";

import { actions as asyncActions } from "../../reducers/asyncServerResponseReducer";

import KeyboardEventHandler from 'react-keyboard-event-handler';
import { configGame } from "../../../data/config";
import { actions as reelsActions } from "../../reducers/reelsStateReducer";
import { actions as gridsActions } from "../../reducers/gridStateReducer";
import { actions as reelsGridActions } from "../../reducers/reelgridStateReducer";
import { TIMER } from "../../utills";
import { actions as reelGridActions } from "../../../core/reducers/reelgridStateReducer";

interface IProps {
    [x: string]: any;
}

interface IState {

}

interface IState {
    isGameLoaded: boolean,
    enableOk: boolean,
    width: number | string,
    height: number | string,
    pixelRatio: number,
    buttonSelected: any,
    selectedautoplayCount: number,
    toggleOn: boolean,


}

interface IStateToProps {
}

interface IDispatchToProps {
}

class KeyboardListener extends Component<IProps, IState> {
    protected app: PIXI.Application;

    protected autoplayContainer: any;


    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.autoplayContainer = React.createRef();
        this.state = {
            width: this.props.width,
            height: this.props.height,
            buttonSelected: "",
            selectedautoplayCount: 0,
            pixelRatio: 1,
            enableOk: false,
            isGameLoaded: false,
            toggleOn: true

        }

    }

    reset() {
        this.props.setValueOfNumberButton(0)
        this.setState((prevState) => {
            return {
                ...prevState,
                buttonSelected: "",
                enableOk: false,

            }
        })
    }


    updateDimensions = () => {
        this.setState((prevState) => {
            return {
                ...prevState,
                width: isMobile && window.screen.availWidth || window.innerWidth,
                height: isMobile && window.screen.availHeight || window.innerHeight,
                pixelRatio: window.devicePixelRatio
            }
        })
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        this.updateDimensions();

    }


    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }


    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        return true;
    }

    onSpin() {


        this.props.getApplicationSpinResponse();

        this.props.stopWinPresentation()
        this.props.setAllButtonDisable();
        this.props.resetReelState();

        if (Number(configGame["SPIN_TYPE"]) === 0) {
            const {
                startSpin
            } = this.props;
            startSpin();
        } else if (Number(configGame["SPIN_TYPE"]) === 2) {
            const {
                startRGSpin
            } = this.props;
            startRGSpin();
        } else {
            const {
                startGridSpin
            } = this.props;
            startGridSpin();
        }
    }

    render() {
        if (this.props.winCelebrationForKeyBoardListener || this.props.showPaytable) {
            return (<></>)
        }
        if ((!this.props.spinWithSpaceBar) || (this.props.showSettingPanelUI)) {
            return (<></>)
        }
        return (
            <div>
                <KeyboardEventHandler
                    handleKeys={['space']}
                    onKeyEvent={(key, e) => {

                        if (!this.props.inFreeGame) {
                            if (this.props.featureJustReTriggered == false) {
                                if (this.props.allSpinComplete && !this.props.winPresentationStart) {

                                    this.onSpin();
                                    // let timer = TIMER.TimerManager.createTimer(500);
                                    // timer.on('end', (e: any, data: any) => {

                                    //     e.remove();
                                    //     this.onSpin();
                                    // })
                                    // timer.start();
                                }
                                if (this.props.allSpinComplete && this.props.winPresentationStart && this.props.phaseCount < 2) {

                                    this.props.setPhaseCount(this.props.phaseCount + 1);
                                }
                            }

                        }

                    }} />
            </div>
        )
    }
}


export default withPixiApp(connect(
    (state: Pick<IStore, 'paytableState' | 'autoplayState' | 'freegameState' | 'desktopSettingPanelState' | 'basegameState' | 'winpresentationState' | 'applicationState' | 'gridsState' | 'reelgridState' | 'reelsState' | 'keyboardListenerState'>): IStateToProps =>
    ({
        showPaytable: state.paytableState.showPaytable,
        featureJustReTriggered: state.freegameState.featureJustReTriggered,
        inFreeGame: state.freegameState.inFreeGame,
        scaleY: state.applicationState.scaleY,
        spinWithSpaceBar: state.keyboardListenerState.spinWithSpaceBar,
        winCelebrationForKeyBoardListener: state.keyboardListenerState.winCelebrationForKeyBoardListener,
        winPresentationStart: state.winpresentationState.winPresentationStart,
        showSettingPanelUI: state.desktopSettingPanelState.showSettingPanel,
        phaseCount: state.winpresentationState.phaseCount,
        allSpinComplete: Number(configGame["SPIN_TYPE"]) === 1 && state.gridsState.allSpinComplete || Number(configGame["SPIN_TYPE"]) === 2 && state.reelgridState.allSpinComplete || Number(configGame["SPIN_TYPE"]) === 0 && state.reelsState.allSpinComplete,
    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        getApplicationSpinResponse: (): any => dispatch(asyncActions.getApplicationSpinResponse()),
        setAllButtonDisable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonDisable(exceptBtnList)),
        resetReelState: (): any => dispatch(Number(configGame["SPIN_TYPE"]) === 0 && reelsActions.resetReelState() || Number(configGame["SPIN_TYPE"]) === 1 && gridsActions.resetReelState() || Number(configGame["SPIN_TYPE"]) === 2 && reelsGridActions.resetReelState()),
        stopWinPresentation: (): any => dispatch(winpresentationAction.stopWinPresentation()),
        setPhaseCount: (phasecount: number): any => dispatch(winpresentationAction.setPhaseCount(phasecount)),
        startSpin: (): any => dispatch(reelsActions.startSpin()),
        startRGSpin: (): any => dispatch(reelGridActions.startSpin()),
        startGridSpin: (): any => dispatch(gridsActions.startSpin()),

    }))(withKeyboardListenerConfiguration(KeyboardListener)));